import styled from 'styled-components';

import { CFG } from '../../../../../../theme/configurator-tokens';
import { SPACE } from '../../../../../../theme/tokens';
import { cardHover } from '../../../../../../theme/configurator-keyframes';
import { Text } from '../../../../../../components';
import { DESIGN, DESIGN_GRADIENTS } from '../../design.tokens';

/** Square logo tile shared by both card variants. */
export const LogoTile = styled.span<{ $size: number }>`
  position: relative;
  display: block;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 16px;
  background: ${DESIGN.logoTile};
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
`;

export const LogoImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

/** Legibility overlay drawn over the warm wash. */
export const Overlay = styled.span<{ $gradient: string }>`
  pointer-events: none;
  position: absolute;
  inset: 0;
  background-image: ${(p) => p.$gradient};
`;

export const Name = styled(Text)`
  font-size: 16px;
  font-weight: 300;
  line-height: 1.2;
  color: ${CFG.base200};
`;

/** Theme name + optional "New" badge on one line. */
export const NameRow = styled.span`
  display: flex;
  /* Baseline, not center: the name here is a <p> that keeps its default bottom margin
     (v0's name/subtitle spacing relies on it), which would pull a centred badge low. */
  align-items: baseline;
  gap: ${SPACE[8]};
`;

export const Subtitle = styled(Text)`
  font-size: 14px;
  line-height: 16px;
  color: ${DESIGN.subtitle};
`;

export const CompactSubtitle = styled(Subtitle)`
  font-size: 14px;
`;

/* --- Featured (hero) card -------------------------------------------------- */
export const Featured = styled.button<{ $selected: boolean }>`
  position: relative;
  display: flex;
  width: 100%;
  cursor: pointer;
  flex-direction: column;
  gap: 48px;
  overflow: hidden;
  border-radius: 22px;
  border: 2px solid ${(p) => (p.$selected ? CFG.brand : DESIGN.cardBorder)};
  padding: 8px;
  text-align: left;
  /* Opaque base so a lighter backdrop can't bleed through the overlay's clear
     edge as a white wash; the warm wash paints over it. */
  background-color: ${DESIGN.cardBase};
  background-image: ${DESIGN_GRADIENTS.featuredWash};

  ${cardHover}
`;

export const FeaturedRow = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Meta = styled.span`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 6px;
`;

/* --- Compact row card ------------------------------------------------------ */
export const Compact = styled.button<{ $selected: boolean }>`
  position: relative;
  display: flex;
  width: 100%;
  cursor: pointer;
  align-items: center;
  gap: 12px;
  overflow: hidden;
  border-radius: 22px;
  border: 1.5px solid ${(p) => (p.$selected ? CFG.brand : DESIGN.cardBorder)};
  padding: 8px;
  text-align: left;
  background: transparent;
  transition: border-color 0.2s ease;

  ${cardHover}
`;

export const CompactLogoWrap = styled.span`
  position: relative;
`;

export const CompactMeta = styled.span`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
`;
